export const requestResources = Object.freeze({
  clientPortalAuth: 'ClientPortalAuth',
  clientPortalTickets: 'ClientPortalTickets',
  clientPortalConfig: 'ClientPortalConfig',
  clientPortalChats: 'ClientPortalChat',
  clientPortalVerification: 'ClientPortalVerification',
  clientPortalPasswordRecovery: 'ClientPortalPwdRecovery',
  clientPortalConfigurations: 'ClientPortalConfiguration',
  clientPortalCompanies: 'clientPortalCompanies',
  clientPortalTicketTemplates: 'clientPortalTicketTemplates',
});
